import {Container, HStack, Image, Square} from "@chakra-ui/react";
import ToffeeSimple from "../toffee-simple.svg";
import React from "react";
import './Footer.css'

function Footer(props) {
    return (
        <footer id={'foot'}>
            <Container minH={"3xs"} maxW={"7xl"} padding={12}>
                <HStack>
                    <Square size={40} padding={7}>
                        <Image
                            src={ToffeeSimple}
                        />
                    </Square>
                </HStack>
            </Container>
        </footer>
    );
}

export default Footer;
